import { useState } from 'react'
import { RegulatoryNotice } from '../components/regulatory/RegulatoryNotice'
import { RegulatoryDateFilters } from '../components/regulatory/RegulatoryDateFilters'
import { ControlledDrugsTable } from '../components/regulatory/ControlledDrugsTable'
import { AntibioticsTable } from '../components/regulatory/AntibioticsTable'
import { RegulatoryExportReports } from '../components/regulatory/RegulatoryExportReports'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs'

interface ControlledDrug {
  id: number
  date: string
  ticket: string
  product: string
  quantity: number
  customer: string
  prescription: string
  seller: string
}

interface Antibiotic {
  id: number
  date: string
  ticket: string
  product: string
  quantity: number
  customer: string
  prescription: string
  doctor: string
  seller: string
}

const controlledDrugs: ControlledDrug[] = [
  {
    id: 1,
    date: '2026-04-27',
    ticket: 'VT-1245',
    product: 'Clonazepam 2mg',
    quantity: 30,
    customer: 'María López García',
    prescription: 'RX-2024-5678',
    seller: 'Carlos Méndez',
  },
  {
    id: 2,
    date: '2026-04-26',
    ticket: 'VT-1238',
    product: 'Alprazolam 0.5mg',
    quantity: 20,
    customer: 'Juan Pérez Soto',
    prescription: 'RX-2024-5645',
    seller: 'Ana Torres',
  },
  {
    id: 3,
    date: '2026-04-25',
    ticket: 'VT-1220',
    product: 'Tramadol 50mg',
    quantity: 15,
    customer: 'Patricia Silva',
    prescription: 'RX-2024-5612',
    seller: 'Carlos Méndez',
  },
]

const antibiotics: Antibiotic[] = [
  {
    id: 1,
    date: '2026-04-27',
    ticket: 'VT-1242',
    product: 'Amoxicilina 500mg',
    quantity: 21,
    customer: 'Luis Ramírez',
    prescription: 'RX-2024-5680',
    doctor: 'Dr. Hernández',
    seller: 'María López',
  },
  {
    id: 2,
    date: '2026-04-26',
    ticket: 'VT-1235',
    product: 'Azitromicina 500mg',
    quantity: 6,
    customer: 'Carmen Ortiz',
    prescription: 'RX-2024-5672',
    doctor: 'Dra. González',
    seller: 'Ana Torres',
  },
  {
    id: 3,
    date: '2026-04-25',
    ticket: 'VT-1228',
    product: 'Ciprofloxacino 500mg',
    quantity: 14,
    customer: 'Roberto Díaz',
    prescription: 'RX-2024-5658',
    doctor: 'Dr. Martínez',
    seller: 'Carlos Méndez',
  },
]

export function Regulatory() {
  const [startDate, setStartDate] = useState('2026-04-01')
  const [endDate, setEndDate] = useState('2026-04-27')

  return (
  <div className="space-y-6 p-6">
    <div>
      <h1 className="text-2xl font-semibold text-header-foreground">
        Módulo Regulatorio
      </h1>

      <p className="mt-1 text-sm text-muted-foreground">
        Reportes de medicamentos controlados y antibióticos
      </p>
    </div>

    {/* Important Notice */}
    <RegulatoryNotice />

    {/* Date Filters */}
    <RegulatoryDateFilters
      startDate={startDate}
      endDate={endDate}
      onStartDateChange={setStartDate}
      onEndDateChange={setEndDate}
    />

    <Tabs defaultValue="controlled" className="space-y-6">
      <TabsList className="bg-muted p-1">
          <TabsTrigger
            value="controlled"
            className="data-[state=active]:bg-card data-[state=active]:text-card-foreground data-[state=active]:shadow-sm"
          >
            Medicamentos Controlados
          </TabsTrigger>

          <TabsTrigger
            value="antibiotics"
            className="data-[state=active]:bg-card data-[state=active]:text-card-foreground data-[state=active]:shadow-sm"
          >
            Antibióticos
          </TabsTrigger>

          <TabsTrigger
            value="reports"
            className="data-[state=active]:bg-card data-[state=active]:text-card-foreground data-[state=active]:shadow-sm"
          >
            Exportar Reportes
          </TabsTrigger>
        </TabsList>

      <TabsContent value="controlled">
        <ControlledDrugsTable data={controlledDrugs} />
      </TabsContent>

      <TabsContent value="antibiotics">
        <AntibioticsTable data={antibiotics} />
      </TabsContent>

      <TabsContent value="export">
        <RegulatoryExportReports />
      </TabsContent>
    </Tabs>
  </div>

  )
}
